(function ($) {
  'use strict';

  Drupal.behaviors.adaptivePlaceholders = {
    attached: false,

    labelMode: function ($input) {
      $input.addClass('js-label-mode label-mode');
      $input.removeClass('js-placeholder-mode placeholder-mode');
    },

    placeholderMode: function ($input) {
      $input.removeClass('js-label-mode label-mode');
      $input.addClass('js-placeholder-mode placeholder-mode');
    },

    toggleMode: function ($input) {
      var self = this;

      if ($input.val() === '') {
        self.placeholderMode($input);
      } else {
        self.labelMode($input);
      }
    },

    bindEvents: function ($input) {
      var self = this;

      // Swap out placeholder/label classes on focus in or out
      $input.on('focusin', function () {
        self.labelMode($input);
      });

      $input.on('focusout', function () {
        self.toggleMode($input);
      });

      $input.on('change', function () {
        self.toggleMode($input);
      });
    },

    adplProcess: function (placeholder, $label) {
      if (!$label[0].hasAttribute('placeholder')) {
        $label.attr('placeholder', placeholder);
      }
      if (!$label[0].hasAttribute('alt')) {
        $label.attr('alt', placeholder);
      }
      if ($label.find('span.label-content').length < 1) {
        $label.wrapInner('<span class="label-content"></span>');
      }
    },

    setupDOM: function ($inputs) {
      var self = this;

      $inputs.each(function () {
        var $input = $(this);

        if (!$input.hasClass('adpl--processed')) {
          let $label = $input.siblings('label');
          const placeholder = $input.attr('placeholder') || $label.attr('placeholder');

          if (!placeholder) {
            return true;
          }

          if ($label.length > 0) {
            $label.remove();
          } else {
            const id = $input.attr('id');

            if (id !== undefined) {
              $label = $('<label class="label" for="' + id + '">' + placeholder + '</label>');
            } else {
              return true;
            }
          }
          self.adplProcess(placeholder, $label);

          // Position the label after the input, required for proper z-index
          $label.insertAfter($input);

          $input.removeAttr('placeholder');

          self.placeholderMode($input);
          self.bindEvents($input);
          self.toggleMode($input);

          // Add CSS class for styling
          $input.addClass('adpl--processed');
        }
      });
    },

    attach: function (context) {
      var self = this;

      if ($('html').hasClass('no-placeholder')) {
        return;
      }

      const $inputs = $('input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="password"], textarea', context).not('.no-adpl');

      self.setupDOM($inputs);
    }
  };
})(jQuery);
